import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useCommonStyles = makeStyles((theme: Theme) =>
  createStyles({
    newTabButton: {
      borderColor: theme.palette.secondary.main,
      color: theme.palette.secondary.main,
      backgroundColor: "white",
      borderWidth: "1px",
      borderStyle: "solid",
      marginLeft: theme.spacing(2),
      "&:hover": {
        backgroundColor: "white",
      },
    },
    // ... add other shared styles here
  })
);